import { Component } from '@angular/core';

import { SnLayoutNavbarContainer } from '../../containers';

@Component({
  selector: 'sn-layout-navbar-collapse-button',
  templateUrl: './layout-navbar-collapse-button.component.html',
  styleUrls: ['./layout-navbar-collapse-button.component.scss'],
  host: {
    class: 'sn-layout-navbar__collapse-button',
  },
})
export class SnLayoutNavbarCollapseButtonComponent {
  constructor(private readonly _navbar: SnLayoutNavbarContainer) {}

  get collapsed(): boolean {
    return this._navbar.collapsed;
  }

  public toggleCollapse(): void {
    this._navbar.toggleCollapse();
  }

  get canSeeSecondaryNavbar(): boolean {
    return this._navbar.canSeeSecondaryNavbar;
  }
}
